import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {urlJoin} from '../../../utils/urlJoin';
import {environment} from '../../../../environments/environment';

@Injectable()
export class StattunepsService {
    constructor(private http: HttpClient) {
    }

    static get base() {
        return urlJoin(environment.server.hostSource, 'portail');
    }

    load_nbr_consultation() {
        const resource = urlJoin(StattunepsService.base, 'stat', 'shop');

        return this.http.get(resource);
    }

    load_nbr_acheteurs() {
        const resource = urlJoin(StattunepsService.base, 'stat', 'inst');

        return this.http.get(resource);
    }

    load_nbr_fournisseurs() {
        const resource = urlJoin(StattunepsService.base, 'stat', 'supplier');

        return this.http.get(resource);
    }

    load_nbr_appels_offres() {
        const resource = urlJoin(StattunepsService.base, 'stat', 'bid');

        return this.http.get(resource);
    }
}
